/**
 * Per-brand feature flags.
 *
 * Add a brand's lowercase key to a list below to turn that feature on for it.
 */

// Brands that ask the "Is it a branded or designer jewelry piece?" question
// and route those items to specialist review instead of an instant estimate.
export const DESIGNER_REVIEW_BRANDS: string[] = ["maxpawn"];

/**
 * Whether this brand asks the branded/designer question and routes those
 * items to specialist review.
 * @param brand - Brand name (case-insensitive)
 */
export const isDesignerReviewBrand = (brand?: string | null): boolean => {
  if (!brand) return false;
  return DESIGNER_REVIEW_BRANDS.includes(brand.toLowerCase());
};
